import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "~/contexts/auth-context";
import { useFeatureFlags } from "~/contexts/feature-flag-context";

import { CompanyBadge } from "~/components/company-badge";
import { NavigationBar } from "./navigation-bar";
import { Header } from "./header";
import { UtilityMenu } from "./utility-menu";

type NavigationItems = ComponentProps<typeof NavigationBar>["items"];

interface AuthHeaderProps {
  displayNavigation?: boolean;
}

export function AuthHeader({ displayNavigation = true }: AuthHeaderProps) {
  const { t } = useTranslation(["general", "components"]);

  const { isLoggedIn } = useAuth();
  const { features } = useFeatureFlags();

  const searchTermsItems: NavigationItems = features.useFeSearchTerms
    ? [
        {
          label: t("components:authHeader.searchTerms"),
          path: "/search-terms",
        },
      ]
    : [];

  const navigationItems: NavigationItems = [
    {
      label: t("components:authHeader.home"),
      path: "/",
      exact: true,
    },
    { label: t("components:authHeader.books"), path: "/books" },
    ...searchTermsItems,
    { label: t("components:authHeader.codes"), path: "/codes" },
    { label: t("components:authHeader.projects"), path: "/projects" },
  ];

  return (
    <Header>
      {!isLoggedIn ? null : (
        <>
          {displayNavigation && <NavigationBar items={navigationItems} />}
          <div className="flex items-center gap-2">
            <CompanyBadge />
            <UtilityMenu />
          </div>
        </>
      )}
    </Header>
  );
}
